import api from '@/lib/api';
import type { LoginRequest, RegisterRequest, AuthResponse, TokenResponse, LoginResult, Login2faRequest } from '@/types/auth';

export const authService = {
  login: async (data: LoginRequest): Promise<LoginResult> => {
    const response = await api.post<LoginResult>('/auth/login', data);
    return response.data;
  },

  login2fa: async (data: Login2faRequest): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/login/2fa', data);
    return response.data;
  },

  register: async (data: RegisterRequest): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/register-tenant', data);
    return response.data;
  },

  refreshToken: async (refreshToken: string): Promise<TokenResponse> => {
    const response = await api.post<TokenResponse>('/auth/refresh', { refreshToken });
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout');
  },
};
